import { render, staticRenderFns } from "./ruler.vue?vue&type=template&id=4b68308a&scoped=true&lang=pug&"
import script from "./ruler.vue?vue&type=script&lang=js&"
export * from "./ruler.vue?vue&type=script&lang=js&"
import style0 from "./ruler.vue?vue&type=style&index=0&id=4b68308a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b68308a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4b68308a', component.options)
    } else {
      api.reload('4b68308a', component.options)
    }
    module.hot.accept("./ruler.vue?vue&type=template&id=4b68308a&scoped=true&lang=pug&", function () {
      api.rerender('4b68308a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/floating_editor/measure/component/ruler.vue"
export default component.exports